import getSupplierPhone1 from 'utils/print/getSupplierPhone1';
import getSupplierPhone2 from 'utils/print/getSupplierPhone2';
import getSupplierPhone3 from 'utils/print/getSupplierPhone3';

const getSupplierFullPhone = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const phone1 = getSupplierPhone1(otherProps);
  const phone2 = getSupplierPhone2(otherProps);
  const phone3 = getSupplierPhone3(otherProps);
  if (phone1 && phone2 && phone3) {
    return `(${phone1}) ${phone2}-${phone3}`;
  }

  return null;
};

export default getSupplierFullPhone;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierFullPhone.js